/**
 * note:
 * 提取自 el-tree: https://github.dev/ElemeFE/element/packages/tree
 * 保留基础功能；移除了拖拽、勾选等特性
 */

import "./src/tree.styl";
import EDTree from "./src/tree.vue";

export default EDTree;
